import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';
import { getGroupsAction } from '../dashboard/groupsReducer';

const initialState = {
  loading: false,
  facilityList: [],
  facilityPayment: ''
};
const facilities = createSlice({
  name: 'facilities',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        facilityList: action.payload?.result,
        count: action.payload?.count
      };
    },
    getById(state, action) {
      return {
        ...state,
        facilityInfo: action.payload
      };
    },
    getFacilityPayment(state, action) {
      return {
        ...state,
        facilityPayment: action.payload
      };
    }
  }
});

export const facilityActions = facilities.actions;

export const getFacilityAction = (data) => async (dispatch) => {
  dispatch(facilityActions.setLoading(true));
  try {
    const res = await api.post(`api/facility/filter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(facilityActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(facilityActions.setLoading(false));
  }
};

export const createFacility = (data) => async () => {
  try {
    const res = await api.post(`api/facility`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const editFacility = (data) => async () => {
  try {
    const res = await api.put(`api/facility`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const getFacilityById = (id) => async (dispatch) => {
  dispatch(facilityActions.setLoading(true));
  try {
    const res = await api.get(`api/facility`, { params: { id } });
    if (res.status === 200 && res?.data) {
      dispatch(facilityActions.getById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(facilityActions.setLoading(false));
  }
};

export const getFacilityPayment = (id) => async (dispatch) => {
  try {
    const res = await api.get(`api/PaymentMethod/Facility${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(facilityActions.getFacilityPayment(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const clearFacilityById = () => async (dispatch) => {
  dispatch(facilityActions.getById(''));
};

export const removeFacilityAction = (id, setRemoveDialog) => async () => {
  try {
    const res = await api.delete(`api/facility`, { params: { id } });
    if (res.status === 200 && res?.data) {
      setRemoveDialog('');
      toast.success('Removed successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const removeUserFromFacility = (data) => async () => {
  try {
    const res = await api.post(`api/facility/DeleteUser`, data);
    if (res.status === 200 && res?.data) {
      toast.success('Removed successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export default facilities.reducer;
